module.exports = __webpack_public_path__ + "static/img/brandIncrease_banner.33fc7021.png";